// removed by extract-text-webpack-plugin
module.exports = {"testimonial":"src-components-Testimonial----styles-module---testimonial---2Qv87","header":"src-components-Testimonial----styles-module---header---2fP2r","stars":"src-components-Testimonial----styles-module---stars---28-hI","star":"src-components-Testimonial----styles-module---star---19n2N","inactive":"src-components-Testimonial----styles-module---inactive---nfAzI","title":"src-components-Testimonial----styles-module---title---1XYVA","author":"src-components-Testimonial----styles-module---author---w7YJx","content":"src-components-Testimonial----styles-module---content---3Azvd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonial/styles.module.css
// module id = 511
// module chunks = 168707334958949